module.exports = __webpack_public_path__ + "img/bg-green.e6eb3a77.png";